'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var normaliseInput = require('ipfs-core-utils/pins/normalise-input');

var utils = require('../../utils.js');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var errCode = require('err-code');

var pinTypes = require('ipfs-repo/pin-types');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

function toPin(type, cid, metadata) {
  var output = {
    type: type,
    cid: cid
  };

  if (metadata) {
    output.metadata = metadata;
  }

  return output;
}

function createLs(_ref) {
  var repo = _ref.repo,
      codecs = _ref.codecs;

  function ls() {
    return _ls.apply(this, arguments);
  }

  function _ls() {
    _ls = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var options,
          type,
          matched,
          _iteratorAbruptCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          path,
          _yield$_awaitAsyncGen,
          cid,
          _yield$_awaitAsyncGen2,
          reason,
          pinned,
          parent,
          metadata,
          _iteratorAbruptCompletion2,
          _didIteratorError2,
          _iteratorError2,
          _iterator2,
          _step2,
          _step2$value,
          _cid,
          _metadata,
          _iteratorAbruptCompletion3,
          _didIteratorError3,
          _iteratorError3,
          _iterator3,
          _step3,
          _cid2,
          _iteratorAbruptCompletion4,
          _didIteratorError4,
          _iteratorError4,
          _iterator4,
          _step4,
          _step4$value,
          _cid3,
          _metadata2,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              type = pinTypes.PinTypes.all;

              if (!options.type) {
                _context.next = 6;
                break;
              }

              type = options.type;

              if (Object.keys(pinTypes.PinTypes).includes(type)) {
                _context.next = 6;
                break;
              }

              throw errCode__default["default"](new Error('Invalid pin type'), 'ERR_INVALID_PIN_TYPE');

            case 6:
              if (!options.paths) {
                _context.next = 61;
                break;
              }

              matched = false;
              _iteratorAbruptCompletion = false;
              _didIteratorError = false;
              _context.prev = 10;
              _iterator = _asyncIterator(normaliseInput.normaliseInput(options.paths));

            case 12:
              _context.next = 14;
              return _awaitAsyncGenerator(_iterator.next());

            case 14:
              if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                _context.next = 42;
                break;
              }

              path = _step.value.path;
              _context.next = 18;
              return _awaitAsyncGenerator(utils.resolvePath(repo, codecs, path));

            case 18:
              _yield$_awaitAsyncGen = _context.sent;
              cid = _yield$_awaitAsyncGen.cid;
              _context.next = 22;
              return _awaitAsyncGenerator(repo.pins.isPinnedWithType(cid, type));

            case 22:
              _yield$_awaitAsyncGen2 = _context.sent;
              reason = _yield$_awaitAsyncGen2.reason;
              pinned = _yield$_awaitAsyncGen2.pinned;
              parent = _yield$_awaitAsyncGen2.parent;
              metadata = _yield$_awaitAsyncGen2.metadata;

              if (pinned) {
                _context.next = 29;
                break;
              }

              throw errCode__default["default"](new Error("path '".concat(path, "' is not pinned")), 'ERR_NOT_PINNED');

            case 29:
              _context.t0 = reason;
              _context.next = _context.t0 === pinTypes.PinTypes.direct ? 32 : _context.t0 === pinTypes.PinTypes.recursive ? 32 : 36;
              break;

            case 32:
              matched = true;
              _context.next = 35;
              return toPin(reason, cid, metadata);

            case 35:
              return _context.abrupt("break", 39);

            case 36:
              matched = true;
              _context.next = 39;
              return toPin("".concat(pinTypes.PinTypes.indirect, " through ").concat(parent), cid, metadata);

            case 39:
              _iteratorAbruptCompletion = false;
              _context.next = 12;
              break;

            case 42:
              _context.next = 48;
              break;

            case 44:
              _context.prev = 44;
              _context.t1 = _context["catch"](10);
              _didIteratorError = true;
              _iteratorError = _context.t1;

            case 48:
              _context.prev = 48;
              _context.prev = 49;

              if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                _context.next = 53;
                break;
              }

              _context.next = 53;
              return _awaitAsyncGenerator(_iterator.return());

            case 53:
              _context.prev = 53;

              if (!_didIteratorError) {
                _context.next = 56;
                break;
              }

              throw _iteratorError;

            case 56:
              return _context.finish(53);

            case 57:
              return _context.finish(48);

            case 58:
              if (matched) {
                _context.next = 60;
                break;
              }

              throw new Error('No match found');

            case 60:
              return _context.abrupt("return");

            case 61:
              if (!(type === pinTypes.PinTypes.recursive || type === pinTypes.PinTypes.all)) {
                _context.next = 91;
                break;
              }

              _iteratorAbruptCompletion2 = false;
              _didIteratorError2 = false;
              _context.prev = 64;
              _iterator2 = _asyncIterator(repo.pins.recursiveKeys());

            case 66:
              _context.next = 68;
              return _awaitAsyncGenerator(_iterator2.next());

            case 68:
              if (!(_iteratorAbruptCompletion2 = !(_step2 = _context.sent).done)) {
                _context.next = 75;
                break;
              }

              _step2$value = _step2.value, _cid = _step2$value.cid, _metadata = _step2$value.metadata;
              _context.next = 72;
              return toPin(pinTypes.PinTypes.recursive, _cid, _metadata);

            case 72:
              _iteratorAbruptCompletion2 = false;
              _context.next = 66;
              break;

            case 75:
              _context.next = 81;
              break;

            case 77:
              _context.prev = 77;
              _context.t2 = _context["catch"](64);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t2;

            case 81:
              _context.prev = 81;
              _context.prev = 82;

              if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                _context.next = 86;
                break;
              }

              _context.next = 86;
              return _awaitAsyncGenerator(_iterator2.return());

            case 86:
              _context.prev = 86;

              if (!_didIteratorError2) {
                _context.next = 89;
                break;
              }

              throw _iteratorError2;

            case 89:
              return _context.finish(86);

            case 90:
              return _context.finish(81);

            case 91:
              if (!(type === pinTypes.PinTypes.indirect || type === pinTypes.PinTypes.all)) {
                _context.next = 121;
                break;
              }

              _iteratorAbruptCompletion3 = false;
              _didIteratorError3 = false;
              _context.prev = 94;
              _iterator3 = _asyncIterator(repo.pins.indirectKeys(options));

            case 96:
              _context.next = 98;
              return _awaitAsyncGenerator(_iterator3.next());

            case 98:
              if (!(_iteratorAbruptCompletion3 = !(_step3 = _context.sent).done)) {
                _context.next = 105;
                break;
              }

              _cid2 = _step3.value;
              _context.next = 102;
              return toPin(pinTypes.PinTypes.indirect, _cid2);

            case 102:
              _iteratorAbruptCompletion3 = false;
              _context.next = 96;
              break;

            case 105:
              _context.next = 111;
              break;

            case 107:
              _context.prev = 107;
              _context.t3 = _context["catch"](94);
              _didIteratorError3 = true;
              _iteratorError3 = _context.t3;

            case 111:
              _context.prev = 111;
              _context.prev = 112;

              if (!(_iteratorAbruptCompletion3 && _iterator3.return != null)) {
                _context.next = 116;
                break;
              }

              _context.next = 116;
              return _awaitAsyncGenerator(_iterator3.return());

            case 116:
              _context.prev = 116;

              if (!_didIteratorError3) {
                _context.next = 119;
                break;
              }

              throw _iteratorError3;

            case 119:
              return _context.finish(116);

            case 120:
              return _context.finish(111);

            case 121:
              if (!(type === pinTypes.PinTypes.direct || type === pinTypes.PinTypes.all)) {
                _context.next = 151;
                break;
              }

              _iteratorAbruptCompletion4 = false;
              _didIteratorError4 = false;
              _context.prev = 124;
              _iterator4 = _asyncIterator(repo.pins.directKeys());

            case 126:
              _context.next = 128;
              return _awaitAsyncGenerator(_iterator4.next());

            case 128:
              if (!(_iteratorAbruptCompletion4 = !(_step4 = _context.sent).done)) {
                _context.next = 135;
                break;
              }

              _step4$value = _step4.value, _cid3 = _step4$value.cid, _metadata2 = _step4$value.metadata;
              _context.next = 132;
              return toPin(pinTypes.PinTypes.direct, _cid3, _metadata2);

            case 132:
              _iteratorAbruptCompletion4 = false;
              _context.next = 126;
              break;

            case 135:
              _context.next = 141;
              break;

            case 137:
              _context.prev = 137;
              _context.t4 = _context["catch"](124);
              _didIteratorError4 = true;
              _iteratorError4 = _context.t4;

            case 141:
              _context.prev = 141;
              _context.prev = 142;

              if (!(_iteratorAbruptCompletion4 && _iterator4.return != null)) {
                _context.next = 146;
                break;
              }

              _context.next = 146;
              return _awaitAsyncGenerator(_iterator4.return());

            case 146:
              _context.prev = 146;

              if (!_didIteratorError4) {
                _context.next = 149;
                break;
              }

              throw _iteratorError4;

            case 149:
              return _context.finish(146);

            case 150:
              return _context.finish(141);

            case 151:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[10, 44, 48, 58], [49,, 53, 57], [64, 77, 81, 91], [82,, 86, 90], [94, 107, 111, 121], [112,, 116, 120], [124, 137, 141, 151], [142,, 146, 150]]);
    }));
    return _ls.apply(this, arguments);
  }

  return withTimeoutOption.withTimeoutOption(ls);
}

exports.createLs = createLs;